import React from 'react';

const Insurance = () => {
    const insuranceData = [
        {
            title: "Health Insurance",
            image: "he.jpg",
            description: "Protect yourself and your family with comprehensive health insurance plans. Get coverage for medical expenses, hospitalization, and critical illnesses.",
            benefits: [
                "Covers hospitalization and treatment costs",
                "Cashless treatment at network hospitals",
                "Tax benefits under Section 80D",
                "Access to a wide network of healthcare providers"
            ]
        },
        {
            title: "Car Insurance",
            image: "car.jpg",
            description: "Secure your vehicle against damages, theft, and third-party liabilities. Choose from a range of plans tailored to your needs.",
            benefits: [
                "Comprehensive coverage for accidents",
                "Covers theft and natural calamities",
                "Third-party liability protection",
                "Hassle-free claims process"
            ]
        },
        {
            title: "Life Insurance",
            image: "life.jpg",
            description: "Ensure your loved ones are financially secure with our life insurance policies. Choose from term plans, whole life plans, and more.",
            benefits: [
                "Financial security for your family",
                "Tax-free payouts to beneficiaries",
                "Flexible premium payment options",
                "Coverage for critical illnesses"
            ]
        },
        {
            title: "Travel Insurance",
            image: "travel.avif",
            description: "Travel worry-free with our travel insurance plans. Get coverage for trip cancellations, medical emergencies, and lost baggage.",
            benefits: [
                "Covers medical emergencies abroad",
                "Compensation for trip cancellations",
                "Protection for lost or delayed baggage",
                "24/7 assistance during travel"
            ]
        }
    ];

    return (
        <div className="container py-5">
            <h1 className="text-center mb-4">Our Insurance Plans</h1>
            <p className="text-center mb-5">Explore our wide range of insurance plans designed to provide comprehensive protection for you and your loved ones. Find the perfect plan to suit your needs.</p>

            <div className="row">
                {insuranceData.map((insurance, index) => (
                    <div className="col-md-6 mb-4" key={index}>
                        <div className="card h-100 shadow-sm">
                            <img src={insurance.image} className="card-img-top" alt={insurance.title} style={{ height: "200px", objectFit: "cover" }} />
                            <div className="card-body d-flex flex-column">
                                <h5 className="card-title">{insurance.title}</h5>
                                <p className="card-text">{insurance.description}</p>
                                <ul className="list-unstyled mt-auto">
                                    {insurance.benefits.map((benefit, i) => (
                                        <li key={i} className="mb-1">
                                            <i className="bi bi-check-circle me-2 text-success"></i>
                                            {benefit}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="card-footer d-flex justify-content-between align-items-center">
                                <button className="btn btn-primary">Learn More</button>
                                <button className="btn btn-success">Get Insured</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Insurance;
